export const Organizationuser = () => (
  <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_652_9719)">
      <path
        d="M36.5341 33.0024V25.9436H21.2399V21.1723C22.9533 20.9819 24.5446 20.3811 25.913 19.4707C25.7825 18.1668 25.2196 16.8984 24.2229 15.9018C21.9294 13.6083 18.1975 13.6082 15.904 15.9018C14.9074 16.8984 14.3443 18.1668 14.2139 19.4707C15.5824 20.3811 17.1737 20.9819 18.887 21.1723V25.9436H3.59289V33.0024H0.0634766V40.0612H9.47524V33.0024H5.94583V28.2965H18.887V33.0024H15.3576V40.0612H24.7694V33.0024H21.2399V28.2965H34.1811V33.0024H30.6517V40.0612H40.0635V33.0024H36.5341Z"
        fill="#BBD0FB"
      />
      <path
        d="M16.5608 12.6082C13.8625 9.64023 16.0147 4.75199 20.0657 4.76642C24.1166 4.75191 26.269 9.64086 23.5707 12.6081C25.641 13.5796 27.2741 15.4111 27.9548 17.7027C34.0214 11.0233 29.1792 0.0279141 20.0655 0.06062C10.9524 0.0278357 6.10951 11.0251 12.1766 17.7027C12.8583 15.4076 14.4938 13.578 16.5608 12.6082Z"
        fill="#BBD0FB"
      />
      <path
        d="M17.71 9.47257C17.71 10.77 18.7655 11.8255 20.0629 11.8255C23.1844 11.6963 23.1835 7.24841 20.0629 7.11963C18.7655 7.11963 17.71 8.17516 17.71 9.47257Z"
        fill="#BBD0FB"
      />
    </g>
    <defs>
      <clipPath id="clip0_652_9719">
        <rect width="40" height="40" fill="white" transform="translate(0.0605469 0.0605469)" />
      </clipPath>
    </defs>
  </svg>
);
